//import { ResearchTypeId } from '@cfra-nextgen-frontend/shared/src/utils';

export enum RoutePaths {
    Home = ''
}

export const AlertRoutes = {
};

export enum PageLid {
    Home = 4
}

export enum PageNames {
    Home = 'Home',
  }

export const PageNamesToRoutePaths: Record<PageNames, RoutePaths> = {
    [PageNames.Home]: RoutePaths.Home
};


export const WealthResearchReportTypeIds = [

];


export enum SortOptions {
    BestMatch = 'Best Match',
    Ascending = 'Ascending',
    Descending = 'Descending',
}


export const enum UrlLoginSource {
    MARKETING = 'marketing',
    WELCOME = 'welcome',
}

export enum LookupValueOpLid {
    LessThan = 1,
    GreaterThan = 2,
    StartsWith = 3,
}

export enum SortByTimeOptions {
    Today = 'Today',
    LastWeek = 'Last Week',
    LastMonth = 'Last Month',
    LastQuarter = 'Last Quarter',
    LastYear = 'Last Year',
}

export const SortOptionsDaysMap: Record<SortByTimeOptions, number> = {
    [SortByTimeOptions.Today]: 0,
    [SortByTimeOptions.LastWeek]: 7,
    [SortByTimeOptions.LastMonth]: 30,
    [SortByTimeOptions.LastQuarter]: 90,
    [SortByTimeOptions.LastYear]: 365,
};